import React from "react";


function RoomList(){
    return (
        <div>

        </div>
    );
}


export default RoomList;